import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { InferType } from 'yup';
import { dealInputSchema } from '../DealForm/inputSchema';

export type IDealData = Omit<InferType<typeof dealInputSchema>, 'useCoordinates'> & {
  propertyType: string;
};

export interface IDealFromSignup {
    orgId: string;
    signUpData: any; // FIXME: match api schema
}

const createDealFromSignup = async ({ signUpData, orgId }: IDealFromSignup): Promise<IDealData> => {
    const response = await axiosInstance.post(
        `${API_ENDPOINTS.DEAL_FROM_SIGNUP(orgId)}`,
        signUpData,
    );
    return response.data;
};

export const useCreateDealFromSignup = (): UseMutationResult<
  IDealData,
  Error,
  IDealFromSignup,
  unknown
> => useMutation({
    mutationFn: createDealFromSignup,
});

export default useCreateDealFromSignup;
